// extracted by mini-css-extract-plugin
export default {"contentWrapper":"QxbTblaXpfwq6LAXlo5s","antLayoutWrapper":"Pec_QjfUndL_aCNYS27u","logo":"diazySjTyofrAluqolDP","header":"zt4c92kFvyhMAnRfTPuk"};